import React from 'react';

import { Page, PageNavigation } from '@ui/components';
import { SoapForm } from './SoapForm';
import './Soap.less';

export function Soap() {
  return (
    <div className="soap">
      <PageNavigation title="SOAP" />
      <Page>
        <Page.Content>
          <div className="soap__wrapper">
            <SoapForm />
          </div>
        </Page.Content>
      </Page>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Soap/Soap.tsx